import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ServerErrorMessage } from '../../../../shared/utils/error';
import SociedadesScreen from './screen';
import { SociedadesAdapter, Sociedad } from '../../../../infraestructure/persistence/rest/SociedadesAdapter';
import { useNotifications } from '../../../../shared/hooks/Notifications';

const SociedadesContainer = () => {

	const api = new SociedadesAdapter();
	const {resultError, exceptionError, launchNotification} = useNotifications();
	let [ sociedades, setSociedades ] = useState<any>([]);
	let result: any;

	useEffect(() => {
		getSociedades();
	}, []);

	useEffect(() => {}, [ sociedades ]);

	const getSociedades = async () => {
		try {
			result = await api.ListarSociedades();
			if(result.data && result.data!=="")
			{
				setSociedades([ ...result.data ] || []);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	const createSociedad = async (sociedad: any) => {
		try {
			result = await api.CrearSociedad(sociedad);
			if(result.data && result.data!=="")
			{
				setSociedades([ ...sociedades,...result.data ] || []);
				launchNotification({type:"success",title:"Creación",message:"Se ha creado una nueva sociedad."})
			}else{resultError()}
		} catch (e) {
			let exception = ServerErrorMessage(e);
			exceptionError(exception)
		}
	};

	const deleteSociedad = async (idSociedad: string) => {
		try {
			result = await api.EliminarSociedad(idSociedad);
			if(result.data && result.data!=="")
			{
				let pos = sociedades.findIndex((s: Sociedad) => s.idSociedad === idSociedad);
				let newData = [ ...sociedades ];
				newData.splice(pos, 1);
				setSociedades([ ...newData ] || []);
				launchNotification({type:"success",title:"Eliminación",message:"Se ha eliminado una sociedad."})
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	const updateSociedad = async (idActual: string,sociedad: Sociedad) => {
		try {
			result = await api.ModificarSociedad(idActual,sociedad);
			if(result.data && result.data!=="")
			{
				let pos = sociedades.findIndex((s: Sociedad) => s.idSociedad === idActual);
				let newData = [ ...sociedades ];
				newData[pos] = result.data[0];
				setSociedades([ ...newData ] || []);
				launchNotification({type:"success",title:"Modificación",message:"Se ha modificado una sociedad."})
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	return (
		<>
		<SociedadesScreen
			data={sociedades}
			handleCreate={createSociedad}
			handleRemove={deleteSociedad}
			handleUpdate={updateSociedad}
		/>
		</>
	);
};

export default SociedadesContainer;
